/**
 * Configuración personalizada de notificaciones (toast)
 * Usa la paleta de colores del sitio
 */

export const customToastConfig = {
  success: {
    icon: '✓',
    style: {
      background: '#FDF5F4', // primary-light (crema)
      color: '#2B3139', // text-main (oscuro)
      border: '2px solid #B4897F', // primary-accent (marrón)
      borderRadius: '0px', // Sin rounded
      padding: '16px 24px',
      fontSize: '14px',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 4px 12px rgba(43, 49, 57, 0.1)',
    },
  },
  error: {
    icon: '✓', // Usamos el mismo icono pero con estilos de error
    style: {
      background: '#FDF5F4', // primary-light (crema)
      color: '#2B3139', // text-main (oscuro)
      border: '2px solid #B4897F', // primary-accent (marrón)
      borderRadius: '0px', // Sin rounded
      padding: '16px 24px',
      fontSize: '14px',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 4px 12px rgba(43, 49, 57, 0.1)',
    },
  },
};

/**
 * Toast de éxito personalizado
 */
export const showSuccessToast = (toast, message) => {
  return toast.success(message, customToastConfig.success);
};

/**
 * Toast de info/confirmación personalizado
 */
export const showInfoToast = (toast, message) => {
  return toast(message, {
    icon: '✓',
    style: {
      background: '#FDF5F4',
      color: '#2B3139',
      border: '2px solid #B4897F',
      borderRadius: '0px',
      padding: '16px 24px',
      fontSize: '14px',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 4px 12px rgba(43, 49, 57, 0.1)',
    },
  });
};

/**
 * Toast de error personalizado
 */
export const showErrorToast = (toast, message) => {
  return toast.error(message, {
    icon: '✗',
    style: {
      background: '#FDF5F4',
      color: '#2B3139',
      border: '2px solid #B4897F',
      borderRadius: '0px',
      padding: '16px 24px',
      fontSize: '14px',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 4px 12px rgba(43, 49, 57, 0.1)',
    },
  });
};
